import { AxiosResponse } from 'axios'
import { http } from '../../utils'
import { Response, Challan } from '../types'

export interface FetchAllChallansAPIResponse extends Response {
  data: Challan[]
}

export function fetchAllChallans(isGst: boolean | null, challanType: string, finYear: string | null, partyId?: string) {
  let url = `/challan/pvt/recent?challan_type=${challanType}`
  if(finYear) {
    url = `${url}&fin_year=${finYear}`
  }
  if(isGst === true || isGst === false) {
    url = `${url}&is_gst=${isGst}`
  }
  if(partyId) {
    url = `${url}&party_id=${partyId}`
  }
  return http
    .get(url)
    .then((response: AxiosResponse) => response)
}

function buildChallansRegisterExportQuery(
  from: string,
  to: string,
  challanType: string,
  isGst: boolean | null
): string {
  const params = [
    `from=${from}`,
    `to=${to}`,
    `challan_type=${encodeURIComponent(challanType)}`,
  ]
  if (isGst === true || isGst === false) {
    params.push(`is_gst=${isGst}`)
  }
  return params.join('&')
}

export function fetchChallansRegisterPdf(
  from: string,
  to: string,
  challanType: string,
  isGst: boolean | null
) {
  const qs = buildChallansRegisterExportQuery(from, to, challanType, isGst)
  return http
    .get(`/challan/pvt/challans_pdf?${qs}`)
    .then(
      (response: AxiosResponse<{ success: boolean; data?: string; message?: string }>) =>
        response.data
    )
}

export function fetchChallansRegisterExcel(
  from: string,
  to: string,
  challanType: string,
  isGst: boolean | null
) {
  const qs = buildChallansRegisterExportQuery(from, to, challanType, isGst)
  return http
    .get(`/challan/pvt/challans_excel?${qs}`)
    .then(
      (response: AxiosResponse<{ success: boolean; data?: string; message?: string }>) =>
        response.data
    )
}
